<template>
  <el-card>
    <app-breadcrumb :items="items"></app-breadcrumb>

    <app-table-paginate
      :key="reloadTable"
      v-if="tableShow"
      routeDelete="no"
      selection="no"
      :tableQuery="getList"
      :tableColumns="tableColumns"
      :limit="limit"
      :search="true"
      :noDisplayActions="true"
      :expand="true"
      :expandData="'history'"
      :expandColumns="expandColumns"
    ></app-table-paginate>
  </el-card>
</template>

<script>
import ApiService from "@/common/api.service";
import moment from "moment-timezone";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import breadcrumb from "@/components/_commons/breadcrumb";

export default {
  name: "historico-acceso-usuario",
  components: {
    "app-table-paginate": tablaConPaginador,
    "app-breadcrumb": breadcrumb
  },
  created() {
    this.get();
  },
  data() {
    return {
      reloadTable: 0,
      items: [
        {
          path: "/auditoria/",
          label: "auditoria"
        },
        {
          path: "/auditoria/access-history-date",
          label: "Histórico de accesos"
        },
        {
          path: "/auditoria/access-history/user-history/",
          label: "Histórico acceso usuario"
        }
      ],

      user_id: this.$route.params.user_id,
      listAPI: false,
      strMonths: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ],
      tableColumns: [
        {
          prop: "name",
          label: "Nombre"
        },
        {
          prop: "last_name",
          label: "Apellidos"
        }
      ],
      expandColumns: [
        {
          prop: "acces_date",
          label: "Hora"
        },
        {
          prop: "page",
          label: "Página"
        },
        {
          prop: "path",
          label: "URL"
        }
      ],
      searchQuery: "",
      deleterow: false,
      limit: 10,
      tableShow: true
    };
  },
  methods: {
    async get() {
      const response = await ApiService.post("auditoria/date-history", {
        token: localStorage.getItem("token"),
        date: this.$route.params.date
      });
      this.listAPI = response.data;
      response.data.filter(e => {
        ApiService.post("auditoria/user-history-to-date", {
          token: localStorage.getItem("token"),
          date: this.$route.params.date,
          id: e.user_id
        }).then(r => {
          return (e.history = r.data.filter(h => {
            h.acces_date = moment(h.acces_date).format("hh:mm a");
            return h;
          }));
        });
        return e;
      });
      this.reloadTable++;
    }
  },
  computed: {
    getList() {
      return this.listAPI;
    }
  },
  filters: {
    moment: function(date) {
      return moment(date)
        .tz("Europe/Madrid")
        .format("DD/MM/YY");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/auditoria/accesshistory/date.vue